import { readItems } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

const directus = getDirectusClient();
export const getBodegas = async () => {
    const response = await directus.request(
      readItems("bodegas", {
        fields: "*",
        sort: "-date_created",
        limit: -1,
      })
    );    
    return response;
  };
  
  export const getBodegasCount = async () => {
    const response = await directus.request(
      readItems("bodegas", {
        fields: "*",
        sort: "-date_created",
        limit: -1,
        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  };